import React from "react";
import {
    TextField,
    Box,
    Typography,
    FormControl,
    Paper,
    FormLabel,
    Button,
    Tooltip,
    IconButton,
    Breadcrumbs,
    MenuItem,
    Alert,
    LinearProgress,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { Formik } from "formik";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
    fetchApidata,
    getFetchData,
    PermissionApprovalVerify,
    postApidata,
    postData,
    requestMail,
} from "../../store/reducers/Formapireducer";
import * as Yup from "yup";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { useEffect, useState, useRef } from "react";
import Popup from "../pages/popup";
import Listviewpopup from "../pages/Lookup";
import Swal from "sweetalert2";
import { LoadingButton } from "@mui/lab";
import { useProSidebar } from "react-pro-sidebar";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import { FinanceSchema } from "../Security/validation";
import { fileUpload } from "../../store/reducers/Imguploadreducer";
import store from "../../index";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import { financeentrySchema } from "../Security/validation";
import { Productautocomplete } from "../../ui-components/global/Autocomplete";
import { formGap } from "../../ui-components/global/utils";
import { leaveAppoval, mailNotify } from "../../store/reducers/Listviewapireducer";
import FileListPopup from "../../ui-components/FIleViewDialog";
import FileUploadIconButton from "../../ui-components/FileUploadButton";
import { attachmentPost } from "../../store/reducers/LoginReducer";
import GradingIcon from '@mui/icons-material/Grading';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import CryptoJS from "crypto-js";


const KEY = CryptoJS.enc.Utf8.parse("1234567890123456"); // 16-byte key
const IV = CryptoJS.enc.Utf8.parse("1234567890123456");
function decryptDataUrlSafe(urlSafeBase64) {
    // Convert back to standard base64
    let base64 = urlSafeBase64.replace(/-/g, "+").replace(/_/g, "/");
    // Add padding if needed
    while (base64.length % 4 !== 0) {
        base64 += "=";
    }

    const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: CryptoJS.enc.Base64.parse(base64) },
        KEY,
        {
            iv: IV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        }
    );

    return decrypted.toString(CryptoJS.enc.Utf8);
}
const Expenseapproval = () => {
    const dispatch = useDispatch();
    const params = useParams();
    const accessID = "TR086";
    var recID = decryptDataUrlSafe(params.id);
    const EMPID = sessionStorage.getItem("EmpId");
    const mode = params.Mode;
    const [open, setOpen] = useState(false);
    var parentID = params.parentID;
    console.log(parentID, "parentID");
    const filtertype = params.filtertype;
    const location = useLocation();
    const navigate = useNavigate();
    const isLoading = useSelector((state) => state.formApi.loading);
    const data = useSelector((state) => state.formApi.Data);
    const listViewurl = useSelector((state) => state.globalurl.listViewurl);
    const [loading, setLoading] = useState(false);
    const [files, setFiles] = useState([]);
    const [error, setError] = useState('');
    const rowSx = { height: 36, '& td, & th': { py: 0.5 } };
    const getLoading = useSelector((state) => state.formApi.getLoading);
    const Finyear = sessionStorage.getItem("YearRecorid");
    const CompanyID = sessionStorage.getItem("companyId");
    // const { toggleSidebar, broken, rtl } = useProSidebar();
    const [showImage, setShowImage] = useState(params.Mode == "IM" ? true : false)
    const validationSchema = Yup.object().shape({
        overhead: Yup.object()
            .nullable()
            .required("Overhead is required"),
    });
    useEffect(() => {
        dispatch(getFetchData({ accessID, get: "get", recID })).then((res) => {
            console.log(res, "response");
            var url = store.getState().globalurl.empGetAttachmentUrl;
            axios
                .get(url, {
                    params: {
                        empId: EMPID,
                        appId: data.RecordID
                    }
                })
                .then((response) => {
                    setFiles(response.data);
                })
                .catch((err) => {
                    setError('Failed to fetch attachments.');
                    console.error(err);
                })
                .finally(() => setLoading(false));
        })
    }, [location.key]);

    const [ImageName, setImgName] = useState("");

    const currentDate = new Date().toISOString().split("T")[0];

    const initialValue = {
        applieddate: mode == "A" ? currentDate : data.AppliedDate,
        managerComments: data.ManagerComments,
        Status: data.Status,
        date: data.FEDate,
        referenceifany: data.Referenceifany,
        amount: data.Amount,
        comments: data.Comments,
        approvedby: data.Approvedby,
        overhead: data.OverheadsRecordID
            ? { RecordID: data.OverheadsRecordID, Name: data.Name }
            : null,
    };
    const isNonMobile = useMediaQuery("(min-width:600px)");
    const fnSave = async (values, resetForm, del) => {
        setLoading(true);

        const idata = {
            RecordID: recID,
            OverheadsRecordID: values?.overhead?.RecordID || 0,
            Name: values?.overhead?.Name || "",
            FEDate: values.date,
            Referenceifany: values.referenceifany,
            Amount: values.amount,
            Comments: values.comments,
            Approvedby: mode == "M" ? params.parentID : EMPID,
            FinanceCategoryType: "E",
            Attachment: ImageName ? ImageName : data.Attachment,
            AppliedDate: values.applieddate,
            Reason: "",
            ManagerComments: values.managerComments,
            Status: mode == "A" ? "AL" : mode == "E" && values.Status == "RC" ? "AL" : values.Status,
            Finyear,
            CompanyID,
            
            Source: "Self",
        };

        let action =
            mode === "A" && !del
                ? "insert"
                : mode === "E" && del
                    ? "harddelete"
                    : "update";
        const response = await dispatch(
            PermissionApprovalVerify({

                RecordID: recID,
                EmployeeID: data.EmployeeID,
                ManagerID: params.managerID,
                Status: values.Status,
                Type: "EE",
                Password: values.password,
                ManagerComments: values.managerComments ? values.managerComments : ""
            })
        );
        if (response.payload.Status === "Y") {
            dispatch(mailNotify({
                EmployeeID: data.EmployeeID,
                ManagerID: params.managerID,
                Reason: "",
                RecordID: recID,
                Source: "M",
                Status: values.Status == "AP" ? "Y" : values.Status == "RJ" ? "N" : "Q",
                Type: "EE"
            })
            );
            toast.success(response.payload.Msg);
            navigate(`/approval/notification/EE/${values.Status}`);
        } else {
            console.log("🚀 ~ DTSaveFn ~ response.payload.Msg:", response.payload.Msg)
            toast.error(response.payload.Msg);
        }
    };

    const [isPopupData, setisPopupdata] = React.useState(false);
    const [selectOHLookupData, setselectOHLookupData] = React.useState({
        OHlookupRecordid: "",
        OHlookupCode: "",
        OHlookupDesc: "",
    });
    if (isPopupData == false) {
        selectOHLookupData.OHlookupRecordid = data.OverheadRecordID;
        selectOHLookupData.OHlookupCode = data.Code;
        selectOHLookupData.OHlookupDesc = data.Name;
    }
    const [selectEMPLOYEELookupData, setselectEMPLOYEELookupData] =
        React.useState({
            EMPLOYEElookupRecordid: "",
            EMPLOYEElookupCode: "",
            EMPLOYEElookupDesc: "",
        });
    if (isPopupData == false) {
        selectEMPLOYEELookupData.EMPLOYEElookupRecordid = data.Approvedby;
        selectEMPLOYEELookupData.EMPLOYEElookupCode = data.ApprovedCode;
        selectEMPLOYEELookupData.EMPLOYEElookupDesc = data.ApprovedName;
    }
    const [openOHPopup, setOpenOHPopup] = useState(false);
    const [openEMPLOYEEPopup, setOpenEMPLOYEEPopup] = useState(false);
    function handleShow(type) {
        if (type == "OH") {
            setOpenOHPopup(true);
        }
        if (type == "EMP" || type == "PRD" || type == "MAT" || type == "FIA") {
            setOpenEMPLOYEEPopup(true);
        }
    }

    //************************** Lookup value assign type based Function *****************/
    const childToParent = (childdata, type) => {
        console.log("type---" + type);
        console.log("Data---" + JSON.stringify(childdata));

        if (type == "OverHead") {
            setisPopupdata(true);
            setselectOHLookupData({
                OHlookupRecordid: childdata.RecordID,
                OHlookupCode: childdata.Code,
                OHlookupDesc: childdata.Name,
            });
            setOpenOHPopup(false);
        }
        if (
            type == "Employee" ||
            type == "Products" ||
            type == "Material" ||
            type == "Fixed Assets"
        ) {
            setisPopupdata(true);
            setselectEMPLOYEELookupData({
                EMPLOYEElookupRecordid: childdata.RecordID,
                EMPLOYEElookupCode: childdata.Code,
                EMPLOYEElookupDesc: childdata.Name,
            });
            setOpenEMPLOYEEPopup(false);
        }
    };
    const ref = useRef(null);
    // *************** GET FILES FROM INPUT *************** //

    const getFileChange = async (event) => {
        setImgName(event.target.files[0]);

        console.log(event.target.files[0]);

        const formData = new FormData();
        formData.append("file", event.target.files[0]);
        formData.append("type", "attachments");

        const fileData = await dispatch(fileUpload({ formData }));

        setImgName(fileData.payload.name);
        console.log(">>>", fileData.payload);
        console.log(
            "🚀 ~ file: Editdeliverychalan.jsx:1143 ~ getFileChange ~ fileData:",
            fileData
        );
        if (fileData.payload.Status == "Y") {
            // console.log("I am here");
            toast.success(fileData.payload.Msg);
        }
    };
    const fnLogOut = (props) => {
        //   if(Object.keys(ref.current.touched).length === 0){
        //     if(props === 'Logout'){
        //       navigate("/")}
        //       if(props === 'Close'){
        //         navigate("/Apps/TR022/Bank Master")
        //       }

        //       return
        //  }
        Swal.fire({
            title: `Do you want ${props}?`,
            // text:data.payload.Msg,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: props,
        }).then((result) => {
            if (result.isConfirmed) {
                if (props === "Logout") {
                    navigate("/");
                }
                if (props === "Close") {
                    navigate(-1);
                }
            } else {
                return;
            }
        });
    };
    async function fileUpload(file, EMPID, action, id, purpose) {
        console.log("🚀 ~ fileUpload ~ file:", file)
        const formData = new FormData();
        formData.append('file', file);
        formData.append('empId', EMPID);
        formData.append('appId', data.RecordID);
        formData.append('type', "EE");
        formData.append('source', "Self");
        formData.append("action", action);
        formData.append("id", id);
        formData.append("purpose", purpose);
        console.log("🚀 ~ fileUpload ~ formData:", formData)
        const respose = await dispatch(attachmentPost({ data: formData }))

        if (respose.payload.success) {
            toast.success(respose.payload.message)
            var url = store.getState().globalurl.empGetAttachmentUrl;
            axios
                .get(url, {
                    params: {
                        empId: EMPID,
                        appId: data.RecordID,

                    }
                })
                .then((response) => {
                    setFiles(response.data);
                })
                .catch((err) => {
                    setError('Failed to fetch attachments.');
                    console.error(err);
                })
                .finally(() => setLoading(false));
        } else {
            toast.success(respose.payload.message)
        }

        console.log("🚀 ~ fileUpload ~ respose:", respose)
    }
    return (
        <React.Fragment>
            {getLoading ? <LinearProgress /> : false}
            <Paper elevation={3} sx={{ margin: "0px 10px", background: "#F2F0F0" }}>
                <Box display="flex" justifyContent="space-between" p={2}>
                    <Box display="flex" borderRadius="3px" alignItems="center">
                        <Breadcrumbs
                            maxItems={3}
                            aria-label="breadcrumb"
                            separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                        >
                            <Typography
                                variant="h5"
                                color="#0000D1"
                                sx={{ cursor: "default" }}
                            // onClick={() => {
                            //   navigate("/Apps/TR136/Finance%20Category");
                            // }}
                            >
                                Expense Entry
                            </Typography>

                            {/* <Typography
              variant="h5"
              color="#0000D1"
              sx={{ cursor: "default" }}
              onClick={() => {
                navigate(
                  `/Apps/Secondarylistview/TR086/Finance Entry/${parentID}/${filtertype}`
                );
              }}
            >
              Finance Entry
            </Typography> */}

                            {/* <Typography
                  variant="h5"
                  color="#0000D1"
                  sx={{ cursor: "default" }}
                  
                >
                  {mode === "A" ? "New"}
                </Typography> */}
                        </Breadcrumbs>
                    </Box>
                    <Box display="flex">
                        {/* <Tooltip title="Expense Entry">
              <IconButton
                onClick={() =>
                  navigate("/Apps/Secondarylistview/TR086/Finance%20Entry/E")
                }
                color="primary"
              >
                <ListAltOutlinedIcon />
              </IconButton>
            </Tooltip> */}
                        <IconButton color="error" onClick={() => fnLogOut("Close")}>
                            <ResetTvIcon />
                        </IconButton>
                        <IconButton>
                            <LogoutOutlinedIcon
                                color="error"
                                onClick={() => fnLogOut("Logout")}
                            />
                        </IconButton>
                    </Box>
                </Box>
            </Paper>
            {!getLoading ? (
                <Paper elevation={3} sx={{ margin: "10px" }}>
                    {/* <Box m="20px"> */}
                    {mode === "IM" && (
                        <Box
                            display="flex"
                            padding={1}
                            justifyContent="flex-end"
                            mt="2px"
                            gridColumn="span 4"
                            gap={2}
                            marginBottom={-5}
                        >
                            <IconButton
                                onClick={() => setShowImage(prev => !prev)}
                            >
                                <ArrowDownwardIcon sx={{ color: "blue" }} />
                            </IconButton>
                        </Box>)}
                    <Formik
                        initialValues={initialValue}
                        onSubmit={(values, { resetForm }) => {
                            setTimeout(() => {
                                fnSave(values);
                            }, 100);
                        }}
                        validationSchema={validationSchema}
                        enableReinitialize={true}
                    >
                        {({
                            errors,
                            touched,
                            handleBlur,
                            handleChange,
                            isSubmitting,
                            values,
                            handleSubmit,
                            setFieldValue,
                            resetForm,
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box
                                    display="grid"
                                    gridTemplateColumns="repeat(4 , minMax(0,1fr))"
                                    gap={formGap}
                                    padding={1}
                                    sx={{
                                        "& > div": {
                                            gridColumn: isNonMobile ? undefined : "span 4",
                                        },
                                    }}
                                >
                                    <FormControl
                                        fullWidth
                                        sx={{ gridColumn: "span 2", gap: "15px" }}
                                    >
                                        <TextField
                                            inputProps={{ readOnly: true }}
                                            name="date"
                                            type="date"
                                            id="date"
                                            label="Date"
                                            variant="standard"
                                            focused
                                            value={values.date}
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            inputFormat="YYYY-MM-DD"
                                            error={!!touched.date && !!errors.date}
                                            helperText={touched.date && errors.date}
                                            autoFocus
                                            required
                                            InputLabelProps={{ shrink: true }}
                                        />

                                        <TextField
                                            name="applieddate"
                                            type="date"
                                            id="applieddate"
                                            label="Applied Date"
                                            variant="standard"
                                            focused
                                            inputFormat="YYYY-MM-DD"
                                            value={values.applieddate}
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            error={!!touched.applieddate && !!errors.applieddate}
                                            helperText={touched.applieddate && errors.applieddate}
                                            sx={{ gridColumn: "span 2" }}
                                            inputProps={{
                                                max: new Date().toISOString().split("T")[0],
                                                readOnly: true,
                                            }}
                                            required

                                            InputLabelProps={{ shrink: true }}
                                        />
                                        <React.Fragment>
                                            <TextField
                                                name="referenceifany"
                                                type="text"
                                                id="referenceifany"
                                                label="Reference If Any"
                                                variant="standard"
                                                focused
                                                inputProps={{ readOnly: true }}
                                                required
                                                value={values.referenceifany}
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                error={
                                                    !!touched.referenceifany && !!errors.referenceifany
                                                }
                                                helperText={
                                                    touched.referenceifany && errors.referenceifany
                                                }
                                            />

                                            <FormControl sx={{ gridColumn: "span 2", display: "flex" }}>

                                                <FormControl
                                                    sx={{
                                                        gridColumn: "span 2",
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <Productautocomplete
                                                        variant="outlined"
                                                        name="overhead"
                                                        disabled
                                                        label={
                                                            <>
                                                                OverHead
                                                                <span style={{ color: "red" }}> * </span>
                                                            </>
                                                        }
                                                        id="overhead"
                                                        value={values.overhead}
                                                        onChange={(newValue) => {
                                                            setFieldValue("overhead", newValue);
                                                        }}
                                                        //  onChange={handleSelectionFunctionname}
                                                        // defaultValue={selectedFunctionName}
                                                        url={`${listViewurl}?data={"Query":{"AccessID":"2032","ScreenName":"OverHead","Filter":"FinanceCategoryType='${parentID}' AND companyID='${CompanyID}'","Any":""}}`}
                                                    />

                                                </FormControl>
                                                {touched.overhead && errors.overhead && (
                                                    <div style={{ color: "red", fontSize: "12px", marginTop: "1px" }}>
                                                        {errors.overhead}
                                                    </div>
                                                )}
                                            </FormControl>

                                            <TextField
                                                name="amount"
                                                type="text"
                                                id="amount"
                                                label="Amount"
                                                variant="standard"
                                                focused
                                                value={values.amount}
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                error={!!touched.amount && !!errors.amount}
                                                helperText={touched.amount && errors.amount}
                                                InputProps={{
                                                    inputProps: {
                                                        readOnly: true,
                                                        style: { textAlign: "right" },
                                                        min: 0,
                                                        max: 24,
                                                    },
                                                }}
                                                required
                                            // disabled={mode == "E" && (values.Status != "AL" && values.Status != "QR")}
                                            />
                                            {/* <TextField
                      name="comments"
                      type="text"
                      id="comments"
                      label="Comments"
                      variant="standard"
                      focused
                      value={values.comments}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={!!touched.comments && !!errors.comments}
                      helperText={touched.comments && errors.comments}
                      autoFocus
                    /> */}
                                            <TextField
                                                fullWidth
                                                variant="outlined"
                                                type="text"
                                                label="Comments"
                                                required
                                                multiline
                                                rows={6}
                                                value={values.comments}
                                                id="comments"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                name="comments"
                                                error={!!touched.comments && !!errors.comments}
                                                helperText={touched.comments && errors.comments}
                                                sx={{
                                                    gridColumn: "span 2",
                                                    backgroundColor: "",
                                                    "& .MuiFilledInput-root": {
                                                        backgroundColor: "",
                                                    },
                                                }}
                                                inputProps={{ readOnly: true }}
                                                focused
                                            />


                                            <TextField

                                                fullWidth
                                                variant="outlined"
                                                type="text"
                                                label="Manager Comments"
                                                required
                                                multiline
                                                rows={6}
                                                value={values.managerComments}
                                                id="managerComments"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                name="managerComments"
                                                sx={{
                                                    gridColumn: "span 2",
                                                }}
                                                focused
                                            />


                                            <TextField
                                                select
                                                label="Status"
                                                id="Status"
                                                name="Status"
                                                value={values.Status}
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                required
                                                focused
                                                variant="standard"
                                            >

                                                <MenuItem value="AP">
                                                    Approved
                                                </MenuItem>
                                                <MenuItem value="RJ">
                                                    Rejected
                                                </MenuItem>
                                                <MenuItem value="QR">Query</MenuItem>

                                            </TextField>



                                        </React.Fragment>
                                    </FormControl>
                                </Box>
                                <Box
                                    display="flex"
                                    justifyContent="end"
                                    mt="20px"
                                    gap="20px"
                                    padding={1}
                                // flexDirection={isNonMobile ? "row" : "column"}
                                >
                                    {data.Status == "AP" && (
                                        <Alert variant="filled" sx={{ mt: 1 }} severity="success">
                                            Your Expense request has been Approved.
                                        </Alert>
                                    )}

                                    {data.Status == "RJ" && (
                                        <Alert variant="filled" sx={{ mt: 1 }} severity="error">
                                            Your Expense request has been Rejected.
                                        </Alert>
                                    )}
                                    {data.Status == "QR" && (
                                        <Alert variant="filled" sx={{ mt: 1 }} severity="warning">
                                            Your Expense request has been Queried.
                                        </Alert>
                                    )}
                                    <TextField
                                        required
                                        name="password"
                                        type="password"
                                        id="password"
                                        label="Password"
                                        variant="standard"
                                        focused
                                        value={values.password}
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        fullWidth={isNonMobile ? false : true}
                                        // sx={{ gridColumn: "span 2", width: 300 }}
                                        inputProps={{ readOnly: data.Status == "AP" || data.Status == "RJ" ? true : false }}
                                    />
                                    <LoadingButton
                                        disabled={data.Status == "AP" || data.Status == "RJ"}
                                        color="success"
                                        variant="contained"
                                        type="submit"
                                        loading={isLoading}
                                    >
                                        Submit
                                    </LoadingButton>
                                </Box>
                            </form>
                        )}
                    </Formik>
                    <Popup
                        title="OverHead"
                        openPopup={openOHPopup}
                        setOpenPopup={setOpenOHPopup}
                    >
                        <Listviewpopup
                            accessID="2032"
                            screenName="OverHead"
                            childToParent={childToParent}
                            filterName={"FinanceCategoryType"}
                            filterValue={parentID}
                        />
                    </Popup>
                    <FileListPopup
                        open={open}
                        onClose={() => setOpen(false)}

                        appId={recID}
                        empId={EMPID}
                    />
                    <Popup
                        title={
                            parentID == "E"
                                ? "Employee"
                                : parentID == "P"
                                    ? "Products"
                                    : parentID == "F"
                                        ? "Fixed Assets"
                                        : "Material"
                        }
                        openPopup={openEMPLOYEEPopup}
                        setOpenPopup={setOpenEMPLOYEEPopup}
                    >
                        <Listviewpopup
                            accessID={
                                parentID == "E"
                                    ? "2024"
                                    : parentID == "P"
                                        ? "2002"
                                        : parentID == "F"
                                            ? "2055"
                                            : "2000"
                            }
                            screenName={
                                parentID == "E"
                                    ? "Employee"
                                    : parentID == "P"
                                        ? "Products"
                                        : parentID == "F"
                                            ? "Fixed Assets"
                                            : "Material"
                            }
                            childToParent={childToParent}
                        />
                    </Popup>
                    {/* </Box> */}
                </Paper>
            ) : (
                false
            )}
            {mode === "IM" && files.length > 0 ? (
                <Box mt={2}
                >
                    <Paper elevation={3} sx={{ padding: 2 }}>
                        {/* <Typography variant="h6" gutterBottom>
              Uploaded Files
            </Typography> */}
                        <TableContainer component={Paper} >
                            <Table size="small">
                                <TableHead>
                                    <TableRow sx={rowSx}>
                                        <TableCell width={20}><strong>S.No</strong></TableCell>
                                        <TableCell><strong>Uploaded Date</strong></TableCell>
                                        <TableCell ><strong>Filename</strong></TableCell>
                                        <TableCell ><strong>Purpose</strong></TableCell>
                                        <TableCell ><strong>Source</strong></TableCell>
                                        <TableCell><strong>View</strong></TableCell>


                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {files.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={4} align="center">
                                                No files uploaded yet.
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        files.map((file, index) => (
                                            <TableRow key={file.id || index} sx={rowSx}>
                                                <TableCell>{index + 1}</TableCell>
                                                <TableCell>{file.uploadedDate}</TableCell>
                                                <TableCell>{file.filename}</TableCell>
                                                <TableCell>{file.purpose}</TableCell>
                                                <TableCell>{file.source}</TableCell>
                                                <TableCell>
                                                    <Tooltip title="Open File">
                                                        <IconButton
                                                            color="primary"
                                                            component="a"
                                                            href={file.url}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            size="small"
                                                        >
                                                            <OpenInNewIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="delete">
                                                        <IconButton
                                                            color="error"
                                                            onClick={() => fileUpload(
                                                                "",
                                                                EMPID,
                                                                "delete",
                                                                file.id,
                                                                file.purpose
                                                            )}
                                                            size="small"
                                                        >
                                                            <DeleteForeverIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell>

                                            </TableRow>
                                        ))
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </Box>
            ) : null}
        </React.Fragment>
    );
};

export default Expenseapproval;
